export default __webpack_public_path__ + "static/media/lab-logo-wavy.080d2fe1.png";